<div id="accordion" class="accordion container overflow-hidden">
  <div class="row gy-5">
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" (click)="onClickExpand('one')">
            <button class="btn btn-link">
              Hvilke lodtyper kan jeg spille med på?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedOne}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            I Klasselotteriet har vi 5 forskellige lodtyper, som er afgørende for, hvor stor din gevinst bliver, hvis
            dit nummer udtrækkes. De fem lodtyper er Megalod, 1/1-lod, ½-lod, ¼-lod og 1/8-lod. Hvis du eksempelvis
            spiller med på et 1/1-lod beholder du hele gevinsten, hvorimod du på et 1/4-lod skal dele gevinsten med 3
            andre. Jo større dit lod er, jo større bliver din gevinst altså. Din vinderchance forøges jo flere
            forskellige lodnumre du spiller på.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" (click)="onClickExpand('two')">
            <button class="btn btn-link collapsed">
              Hvordan spiller jeg med?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedTwo}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
          <div class="card-body">
            Det er helt enkelt at spille med i Klasselotteriet. Du vælger de lodder du ønsker at spille på, og opretter
            dig herefter som kunde. Her tilmeldes din betaling automatisk til Betalingsservice. Hvis du gerne vil
            hurtigt i gang med at spille i vores lotteri, kan du betale den første måned med dit betalingskort. Dette
            valg foretager du ved check-ud. Herefter går det helt automatisk med din betaling og udbetaling af
            gevinster.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" (click)="onClickExpand('three')">
            <button class="btn btn-link collapsed">
              Hvor stor er min chance for at vinde i Klasselotteriet?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedThree}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body">
            Hvis du spiller med på ét lodnummer i Klasselotteriet er den statistiske sandsynlighed for at du vinder 41%
            pr. år. Jo flere forskellige lodnumre du spiller med på, jo større bliver sandsynligheden for at du vinder.
            Hvis du eksempelvis spiller med på 4 forskellige lodnumre, er din årlige vinderchance hele 88%.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree" (click)="onClickExpand('four')">
            <button class="btn btn-link collapsed">
              Hvor meget kan jeg vinde i Klasselotteriet?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedFour}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body">
            Der er 52 millioner i puljen hver måned, som fordeler sig på 22.057 gevinster mellem 1.200 og 2.000.000 kr.
            Størrelsen på din mulige gevinst afhænger af hvilken lodtype du spiller med på. Spiller du med på et 1/1-lod
            tilfalder hele beløbet dig, hvorimod du med et ¼ lod skal dele gevinsten med 3 andre osv. Spiller du på et
            Megalod lægges der 50% oveni gevinsten – og du kan dermed vinde op til 3 mio. kr. <br>
            Der skal efter gældende lov betales en afgift på 15% af den del af hver enkelt gevinst, der overstiger 200 kr. 
            Gevinstafgiften er fratrukket, inden dine gevinster udbetales.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseOne" (click)="onClickExpand('five')">
            <button class="btn btn-link">
              Hvordan finder jeg ud af, om jeg har vundet i Klasselotteriet?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedFive}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseFive" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            Du kan finde ud af om du er blevet en af de heldige vindere i en trækning på flere måder. Har du tilmeldt
            dig Gevinstmail eller –SMS, kontakter vi dig direkte, hvis dit lod bliver udtrukket. Du kan også tjekke, om
            du har vundet i trækningslisterne, som offentliggøres dagligt på vores hjemmeside i trækningsperioden.
            Alternativt, kan du tjekke om der er gevinst på dit lodnummer ved at trykke <span class="link-blue" (click)="showPage('/har-jeg-vundet')">her</span>.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseThree" (click)="onClickExpand('eight')">
            <button class="btn btn-link collapsed">
              Hvordan foregår trækningen?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedEight}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseEight" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body">
            Hver måned fra d. 15. til 19. kan du glæde dig til 5 spændende trækningsdage, hvor de mange millioner fordeles. 
            Samtlige 500.000 lodder deltager i månedens trækning, som foregår under Spillemyndighedens bevågenhed. 
            Læs mere om vores trækning <span class="link-blue" (click)="showPage('/support/om-spillet/hvordan-foregar-traekningerne')">her</span>.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseTwo" (click)="onClickExpand('six')">
            <button class="btn btn-link collapsed">
              Hvor og hvornår får jeg udbetalt min gevinst?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedSix}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseSix" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
          <div class="card-body">
            Bliver du en af de mange glade vindere, udbetales din gevinst 2. bankdag i måneden efter dit lod er
            udtrukket. Pengene udbetales til den konto, som er knyttet til din Betalingsservice. For fysiske lodbeviser
            skal du henvende dig til din forhandler for at få udbetalt gevinsten. Læs mere om gevinstudbetaling <span class="link-blue" (click)="showPage('/support/gevinster/hvornar-bliver-min-gevinst-udbetalt')">her</span>.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card col-12">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree" (click)="onClickExpand('seven')">
            <button class="btn btn-link collapsed">
              Hvordan ændrer eller opsiger jeg mine lodder?
            </button>
            <div class="arrow">
              <div class="arrow-icon" [ngClass]="{'rotate-arrow': expandedSeven}"></div>
            </div>
          </h5>
        </div>
        <div id="collapseSeven" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body">
            Ønsker du at foretage ændringer eller opsige dine lodder, så sidder vi klar til at hjælpe dig. Du kan ringe
            til os på 33420900 på hverdage mellem 9.00-18.00. Du bedes have dit kundenummer klar, når du ringer. Dit
            kundenummer finder du ved at logge ind på Min side under Mine oplysninger, eller i breve/nyhedsbreve du har
            modtaget fra os.
          </div>
        </div>
      </div>
    </div>

  </div>
</div>